module.exports = __webpack_public_path__ + "02_medium_black.af18bb25.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_medium_black.png
// module id = Y2js
// module chunks = 0